import { jsx as e, jsxs as w } from "react/jsx-runtime";
import J from "classnames";
import { forwardRef as Q, isValidElement as X, useMemo as d, cloneElement as _ } from "react";
import n from "./index.es5444.js";
import { getComponentDisplayName as Y } from "./index.es670.js";
import { MenuItemWrapper as K } from "./index.es5445.js";
import { kebabCase as R } from "lodash";
import { getAriaAttributes as S } from "./index.es504.js";
import { useTheme as C } from "./index.es173.js";
import { ColorIndicator as k } from "./index.es26.js";
import { useScreenZoom as D } from "./index.es530.js";
import { LockIcon as L } from "./index.es295.js";
import { Skeleton as tt } from "./index.es65.js";
import { onKeyDownEnter as rt } from "./index.es500.js";
import { BodyText as et } from "./index.es487.js";
const Nt = 41, $t = Q(
  ({
    label: o,
    isSelected: m,
    hasDivider: j,
    LeftComponent: s,
    isLeftComponentIcon: I = !0,
    RightComponent: i,
    isRightComponentIcon: N = !0,
    isDisabled: r,
    entity: l,
    onMouseEnter: $,
    onMouseLeave: x,
    onClick: f,
    onKeyDown: p,
    isMulti: z,
    colorIndicator: y,
    tooltip: H,
    wrapperStyle: E,
    isLocked: u,
    testId: A,
    onLockedClick: h,
    role: c = "menuitem",
    isLoading: O = !1,
    ...Z
  }, v) => {
    const a = `${A ? `${R(A)}-` : ""}menu-item`, F = C(), { zoomPercentage: G } = D(), P = G >= 200, g = (typeof o == "string" || typeof o == "number") && !X(o), M = J(
      n.item,
      {
        [n.isMultiItem]: z,
        [n.hasDivider]: j,
        [n.isDisabled]: !g && r
      },
      "placer-ui-menu-item"
    ), B = d(() => ({
      "data-pl-state": r ? "disabled" : "enabled"
    }), [r]), U = d(() => c ? S(c, !!m) : {}, [c, m]), W = d(() => {
      let t = null;
      if (!s && !l) return null;
      if (l)
        t = /* @__PURE__ */ e(
          k,
          {
            entityColor: l,
            disabled: r,
            color: y,
            testId: `${a}-color-indicator`
          }
        );
      else if (s)
        return I ? t = _(s, {
          ...r ? { color: "outline" } : {},
          outline: r ? "disabled" : "default-gray"
        }) : t = s, /* @__PURE__ */ e("span", { className: n.LeftComponent, "data-testid": a + "-left-component", children: t });
      return /* @__PURE__ */ e("span", { className: n.LeftComponent, children: t });
    }, [s, y, l, r, I, a]), b = d(() => {
      if (u)
        return /* @__PURE__ */ e("span", { className: n.RightComponent, "data-testid": `${a}-locked`, children: /* @__PURE__ */ e(L, { size: 16 }) });
      if (!i) return null;
      let t;
      return N ? t = _(i, {
        ...r ? { color: "outline" } : {},
        outline: r ? "disabled" : "default-gray"
      }) : t = i, /* @__PURE__ */ e("span", { className: n.RightComponent, "data-testid": `${a}-right-component`, children: t });
    }, [i, r, N, a, u]);
    let T = o;
    g && (T = /* @__PURE__ */ e(
      et,
      {
        variant: m ? "bold" : "regular",
        element: "p",
        color: r ? "disabled" : "primary",
        isEllipsis: !P,
        children: o
      }
    ));
    const V = (t) => {
      u ? h == null || h(t) : f == null || f(t);
    }, q = (t) => {
      p == null || p(t), rt(t, V, !1);
    };
    return O ? /* @__PURE__ */ e("div", { className: M, style: E, children: /* @__PURE__ */ e(
      tt,
      {
        isVisible: !0,
        height: "16px",
        width: "100%",
        margin: `${F.spacings.s}`,
        "aria-label": "skeleton loading for item",
        "aria-busy": !0
      }
    ) }) : /* @__PURE__ */ e(K, { tooltip: H, testId: `${a}-tooltip`, children: /* @__PURE__ */ w(
      "div",
      {
        ref: v,
        className: M,
        onClick: V,
        onMouseEnter: $,
        onFocus: $,
        onMouseLeave: x,
        onBlur: x,
        onKeyDown: q,
        "data-testid": a,
        style: E,
        "aria-label": g ? o : Y(o),
        role: c,
        "aria-disabled": r,
        "aria-details": u ? "Menu Item in locked state" : B["aria-details"],
        tabIndex: r ? -1 : 0,
        "data-selected": m,
        ...U,
        ...B,
        ...Z,
        children: [
          W,
          T,
          b
        ]
      }
    ) });
  }
);
export {
  Nt as BASIC_MENU_ITEM_HEIGHT,
  $t as BasicMenuItem
};
//# sourceMappingURL=index.es77.js.map
